import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
// Importa useUser para la comprobación de sesión en el cliente
import { useUser } from "@auth0/nextjs-auth0/client"; // Asegúrate que la ruta de import es la correcta para tu versión
import { useAppContext } from "../context/state";
import plavedLogo from "../Assets/images/plavedLogo.png";
import { Button } from "../Components/Common/Button";
import { useRouter } from "next/router";
import { auth, database } from "../config/firebase"; // Mantener si son usados indirectamente o re-exportados intencionalmente

// Re-export for backwards compatibility (Mantener si es necesario)
export { auth, database };

console.log('IndexPage: Component rendering');

// --- Componente NotLoggedIn (Sin cambios necesarios) ---
const NotLoggedIn = ({ router }) => {
  const [currentDateTime, setCurrentDateTime] = useState(null);

  useEffect(() => {
    setCurrentDateTime(new Date());
  }, []);

  const handleLogin = async () => {
    // Always use relative URL to preserve cookies and session state
    await router.push('/api/auth/login');
  };

  const handleRegister = async () => {
    // Use relative URL for registration
    await router.push('/api/auth/register');
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-plaved">
      <div className="bg-white p-4 rounded-[25px] shadow-md w-3/4 max-w-md min-h-72 mx-2 flex items-center justify-center">
        <div className="flex flex-col items-center justify-center space-y-6">
          <img src={plavedLogo.src} className="w-48 h-auto" alt="PLAVED Logo" />
          {currentDateTime && (
            <h1 className="text-lg font-bold text-center text-plaved">
              {currentDateTime.toLocaleString("es-ES", { timeZone: 'Europe/Madrid' })} {/* Añadido timeZone para consistencia */}
            </h1>
          )}
          <div className="flex flex-row justify-center items-center gap-4">
            <Button
              primary
              lg
              onClick={handleLogin}
            >
              Iniciar sesión
            </Button>
            <Button
              tertiary
              lg
              onClick={handleRegister}
            >
              Crear cuenta
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- Componente IndexPage (Modificado) ---
const IndexPage = () => {
  console.log('IndexPage: useUser hook calling');
  const { setSessionData } = useAppContext();
  const { user, error, isLoading } = useUser(); // Hook de Auth0 para el cliente
  const router = useRouter();

  console.log('IndexPage: useUser state:', { isLoading, user: !!user, error });


  useEffect(() => {
    console.log('IndexPage: First useEffect running', { isLoading, user: !!user });
    // Limpiar datos de sesión al llegar aquí (si el usuario no está logueado)
    // Esta lógica puede permanecer si es tu intención.
    if (!isLoading && !user) {
         setSessionData({});
    }
  }, [isLoading, user, setSessionData]);

  useEffect(() => {
    console.log('IndexPage: Second useEffect (redirection logic) running', { isLoading, user: !!user });
    // Lógica de redirección movida al cliente
    if (!isLoading && user) {
      // Si la carga terminó y hay usuario, redirige a /home
      router.replace("/home"); // Usamos replace para no guardar esta página en el historial
    }
  }, [isLoading, user, router]);

  // --- Manejo de Estados ---
  console.log('IndexPage: Evaluating render state', { isLoading, user: !!user, error });

  // 1. Mientras se comprueba la sesión, mostrar un loader (opcional pero recomendado)
  if (isLoading) {
    // Puedes poner un spinner o simplemente null para una pantalla en blanco brevemente
    return <div className="flex items-center justify-center min-h-screen bg-plaved">Cargando...</div>;
  }

  // 2. Si hubo un error cargando el usuario (poco común, pero posible)
  if (error) {
     console.error("Error loading user session:", error);
     // Puedes mostrar un mensaje de error o simplemente mostrar la pantalla de login
     return <NotLoggedIn router={router} />;
  }

  // 3. Si no está cargando y NO hay usuario, renderizar la pantalla de login/registro
  if (!user) {
    return <NotLoggedIn router={router} />;
  }

  // 4. Si no está cargando y SÍ hay usuario, no renderizar nada aquí,
  //    porque el useEffect anterior ya habrá iniciado la redirección.
  //    Devolver null evita un "flash" del contenido de NotLoggedIn.
  return null;
};

export default IndexPage;